import React, { memo, useState, useCallback, useMemo, useEffect } from 'react';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import {
  getArraySort,
} from '@gp/utils/common';
import {
  fetchStudioOverallOverviewPageData,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { useRequest } from 'ahooks';
// import './index.scss';

interface FilterPropsType {
  onChange: (payload: {bo: string[], project: string[]}) => void,
  /* setBOStudioMap: React.Dispatch<React.SetStateAction<{
    [keyName: string]: string[];
  } | null>> | null, */
}

const DEFAULT_PROPS: FilterPropsType = {
  onChange: () => {},
  // setBOStudioMap: null,
};

function Filter(props: FilterPropsType) {

  const {
    onChange,
    // setBOStudioMap,
  } = props;

  const [selectBO, setSelectBO] = useState<string[]>([]);
  const [lastSelectBO, setLastSelectBO] = useState<string[]>([]);
  const [selectProject, setSelectProject] = useState<string[]>([]);
  const [lastSelectProject, setLastSelectProject] = useState<string[]>([]);

  // 筛选器数据
  const {
    loading: filterLoading,
    data: filterList,
  } = useRequest(
    fetchStudioOverallOverviewPageData,
    {defaultParams: [{page: 'projects'}]},
  );

  const boOptions = useMemo(() => {
    const options = [];
    const boList = filterList?.management_team;
    if (Array.isArray(boList) && boList?.length) {
      // 先排序
      let isIncludeOthersItem = false;
      const filterOthersBOlist = boList?.filter((t: string) => {
        if (t?.toLowerCase() === 'others') {
          isIncludeOthersItem = true;
        }
        return t?.toLowerCase() !== 'others';
      });
      const tempSortBOList = getArraySort(filterOthersBOlist, 'string', 'asc');
      const sortBOList = isIncludeOthersItem ? [...tempSortBOList, 'Others'] : tempSortBOList;
      for(let i = 0; i < sortBOList?.length; i ++) {
        const t = sortBOList?.[i];
        options.push({
          text: t,
          value: t,
          groupKey: 'separated',
        });
      }
    }

    return options;
  }, [filterLoading]);

  const projectOptions = useMemo(() => {
    const projectList = filterList?.dev_projects;
    if (!Array.isArray(projectList) || !projectList?.length) {
      return [];
    }
    const _options = getArraySort(projectList, 'string', 'asc', 'name')?.map((t: {id: string, name: string}) => {
      return {
        value: t?.id || '',
        label: t?.name || '-',
        text: t?.name || '-',
        groupKey: 'separated',
      };
    }) || [];

    return _options;
  }, [filterLoading]);

  const handleBOFilterChange = useCallback((v: string[]) => {
    // 重复全选的效果不请求接口
    if (v?.length === filterList?.management_team?.length && !lastSelectBO?.length) return;
    // 当length是全选时，也设置成[]
    if (v?.length === filterList?.management_team?.length) {
      setSelectBO([]);
      setLastSelectBO([]);
      onChange({
        bo: [],
        project: selectProject,
      });
      return;
    }

    const newSelectBO = v ? [...v] : [];
    setSelectBO(newSelectBO);
    setLastSelectBO(newSelectBO);
    onChange({
      bo: newSelectBO,
      project: selectProject,
    });
  }, [filterList?.management_team?.length, lastSelectBO, selectProject]);

  const handleProjectFilterChange = useCallback((v: string[]) => {
    // 重复全选的效果不请求接口
    if (v?.length === filterList?.dev_projects?.length && !lastSelectProject?.length) return;
    // 当length是全选时，也设置成[]
    if (v?.length === filterList?.dev_projects?.length) {
      setSelectProject([]);
      setLastSelectProject([]);
      onChange({
        bo: selectBO,
        project: [],
      });
      return;
    }

    const newSelectProject = v ? [...v] : [];
    setSelectProject(newSelectProject);
    setLastSelectProject(newSelectProject);
    onChange({
      bo: selectBO,
      project: newSelectProject,
    });
  }, [filterList?.dev_projects?.length, lastSelectProject, selectBO]);

  /* useEffect(() => {
    if (!filterLoading) {
      setBOStudioMap?.(filterList?.bo_studios_map || null);
    }
  }, [filterLoading]); */

  return (
    <>
      <GPSelectMultiple
        className="dbg-studio-overall-projects-dev-bo-selector"
        style={{marginRight: 10}}
        label="Business Owner"
        searchable
        disabled={filterLoading}
        options={boOptions}
        value={selectBO}
        onChange={handleBOFilterChange}
      />
      <GPSelectMultiple
        className="dbg-studio-overall-projects-dev-project-selector"
        label="Project"
        searchable
        disabled={filterLoading}
        options={projectOptions}
        value={selectProject}
        onChange={handleProjectFilterChange}
      />
    </>
  );
}

Filter.defaultProps = DEFAULT_PROPS;

export default memo(Filter);
